module.exports = __webpack_public_path__ + "img/kattamya.55f05136.jpg";